import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Globe, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const navItems = [{
    name: t('nav.about'),
    path: '/about',
    external: false
  }, {
    name: t('nav.philosophy'),
    path: '/philosophy',
    external: false
  }, {
    name: t('nav.solutions'),
    path: '/solutions',
    external: false
  }, {
    name: t('nav.technology'),
    path: '/technology',
    external: false
  }, {
    name: t('nav.ethics'),
    path: '/ethics',
    external: false
  }, {
    name: t('nav.insights'),
    path: 'https://netkrida.co.id',
    external: true
  }, {
    name: t('nav.contact'),
    path: '/contact',
    external: false
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-carbon/90 backdrop-blur-md" data-id="element-91">
      <div className="max-w-[1800px] mx-auto px-6 h-20 flex items-center justify-between" data-id="element-92">
        <Link to="/" className="flex flex-col group" data-id="element-93">
          <span className="font-display font-bold text-xl tracking-tighter text-ivory group-hover:text-white transition-colors" data-id="element-94">
            NEW ASIA TECH
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-muted-gold" data-id="element-95">
            System Sovereign
          </span>
        </Link>

        <nav className="hidden lg:flex items-center space-x-8" data-id="element-96">
          {navItems.map(item => item.external ? <a key={item.path} href={item.path} target="_blank" rel="noopener noreferrer" className="relative text-sm uppercase tracking-widest transition-all duration-300 text-ai-teal font-bold flex items-center group px-3 py-1 border border-ai-teal/30 bg-ai-teal/5 hover:bg-ai-teal/10 hover:border-ai-teal/50 rounded-sm" data-id="element-97">
                <span className="relative z-10" data-id="element-98">{item.name}</span>
                <ExternalLink className="w-3 h-3 ml-2 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-99" />
                <div className="absolute inset-0 bg-ai-teal/0 group-hover:bg-ai-teal/5 transition-colors rounded-sm" data-id="element-100" />
              </a> : <Link key={item.path} to={item.path} className={`text-sm uppercase tracking-widest transition-colors duration-300 ${location.pathname === item.path ? 'text-ai-teal' : 'text-graphite hover:text-ivory'}`} data-id="element-101">
                {item.name}
              </Link>)}

          <div className="flex items-center space-x-2 ml-4 border-l border-white/10 pl-4" data-id="element-102">
            <Globe className="w-4 h-4 text-graphite" data-id="element-103" />
            <button onClick={() => setLanguage('en')} className={`text-xs font-mono uppercase tracking-widest transition-colors ${language === 'en' ? 'text-ai-teal' : 'text-graphite hover:text-ivory'}`} data-id="element-104">
              EN
            </button>
            <span className="text-graphite" data-id="element-105">|</span>
            <button onClick={() => setLanguage('id')} className={`text-xs font-mono uppercase tracking-widest transition-colors ${language === 'id' ? 'text-ai-teal' : 'text-graphite hover:text-ivory'}`} data-id="element-106">
              ID
            </button>
          </div>
        </nav>

        <button className="lg:hidden text-ivory p-2" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-107">
          {isOpen ? <X size={24} data-id="element-108" /> : <Menu size={24} data-id="element-109" />}
        </button>
      </div>

      {isOpen && <div className="lg:hidden absolute top-20 left-0 right-0 bg-carbon border-b border-white/10 p-6 flex flex-col space-y-4 animate-in slide-in-from-top-5" data-id="element-110">
          {navItems.map(item => item.external ? <a key={item.path} href={item.path} target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="text-lg font-display uppercase tracking-wider text-ai-teal font-bold flex items-center border border-ai-teal/30 bg-ai-teal/5 p-3 rounded-sm" data-id="element-111">
                {item.name}
                <ExternalLink className="w-4 h-4 ml-2" data-id="element-112" />
              </a> : <Link key={item.path} to={item.path} onClick={() => setIsOpen(false)} className={`text-lg font-display uppercase tracking-wider ${location.pathname === item.path ? 'text-ai-teal' : 'text-graphite hover:text-ivory'}`} data-id="element-113">
                {item.name}
              </Link>)}

          <div className="flex items-center space-x-4 pt-4 border-t border-white/10" data-id="element-114">
            <Globe className="w-4 h-4 text-graphite" data-id="element-115" />
            <button onClick={() => setLanguage('en')} className={`text-sm font-mono uppercase tracking-widest transition-colors ${language === 'en' ? 'text-ai-teal' : 'text-graphite hover:text-ivory'}`} data-id="element-116">
              ENGLISH
            </button>
            <span className="text-graphite" data-id="element-117">|</span>
            <button onClick={() => setLanguage('id')} className={`text-sm font-mono uppercase tracking-widest transition-colors ${language === 'id' ? 'text-ai-teal' : 'text-graphite hover:text-ivory'}`} data-id="element-118">
              INDONESIA
            </button>
          </div>
        </div>}
    </header>;
}